@use '@/styles/tokens' as *;

/* The Field Mapping screen's top-inline-end cluster (Figma 587:524140 Undo at x=1257, over
 * 587:523586 the tool column at x=1343). Absolute inside the map AREA, not inside the map, for the
 * same reason `<MapControlStack>` is: chrome must not move when the Grower pans (113584 §4a).
 *
 * D-01: `top` matches `.topControls`'s own value on the Map (99px) rather than the pre-full-bleed
 * `var(--space-4)` — this row sits under the now-floating `<TopNav>` pill the same way that one
 * does, and the two source frames above predate the full-bleed layout, so there is no equivalent
 * frame to re-measure this cluster's own gap against; 99px keeps every top-row cluster consistent
 * until one exists.
 *
 * `z-index: 2` matches the control stack — clear of the canvas, far below antd's 1000 overlay base
 * so ticket 10's modals render over it. */
.toolbar {
  position: absolute;
  top: 99px;
  inset-inline-end: var(--space-16);
  z-index: 2;
  display: flex;
  align-items: flex-start;
  /* Figma 19px between Undo's right edge and the tool column. */
  gap: var(--space-5);
}

/* Figma 587:523586 — a 32px column. No --space-* token sits at 32 as a SIZE, and none sits at 6 for
 * the gap; `map-control-stack.module.scss` records the same two facts for its own 36/6. */
.tools {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 32px;
}

.tool {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: $radius-md;
  /* Figma 587:523590 — a white wash over the imagery. */
  background: $color-map-tool-unselected;
  color: $color-white-100;
  cursor: pointer;

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }
}

/* Figma 587:523587 — the selected tool is opaque black. */
.selected {
  background: $color-map-tool-selected;
}

.glyph {
  display: block;
  width: 20px;
  height: 20px;
}
